import React, { useState, useRef, useEffect } from 'react';
import '../css/ContactCustomerService.css';

function ContactCustomerService() {
  const [isBoxOpen, setIsBoxOpen] = useState(false);
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([
    { from: 'support', text: 'Hello! How can we help you today?' }
  ]);
  const messagesEndRef = useRef(null);

  const handleOpen = () => {
    setIsBoxOpen(true);
  };

  const handleClose = () => {
    setIsBoxOpen(false);
    setInput('');
    setMessages([
      { from: 'support', text: 'Hello! How can we help you today?' }
    ]);
  };

  const handleSend = (e) => {
    e.preventDefault();
    if (!input.trim()) return;
    setMessages(prev => [
      ...prev,
      { from: 'user', text: input }
    ]);
    setInput('');
    // Simulate support reply after 1s
    setTimeout(() => {
      setMessages(prev => [
        ...prev,
        { from: 'support', text: 'Thank you for your message! Our team will reply shortly.' }
      ]);
    }, 1000);
  };

  useEffect(() => {
    if (isBoxOpen && messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, isBoxOpen]);

  return (
    <div className="contact-customer-service">
      <button className="contact-btn" onClick={handleOpen}>
        💬Contact Us
      </button>
      {isBoxOpen && (
        <div className="chat-popup-box">
          <div className="contact-modal chat-modal">
            <button className="close-btn" onClick={handleClose}>×</button>
            <h2>Customer Service Chat</h2>
            <div className="chat-messages">
              {messages.map((msg, idx) => (
                <div
                  key={idx}
                  className={`chat-message ${msg.from === 'user' ? 'user' : 'support'}`}
                >
                  {msg.text}
                </div>
              ))}
              <div ref={messagesEndRef} />
            </div>
            <form className="chat-input-row" onSubmit={handleSend}>
              <input
                className="chat-input"
                type="text"
                placeholder="Type your message..."
                value={input}
                onChange={e => setInput(e.target.value)}
                autoFocus
              />
              <button className="send-btn" type="submit">Send</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default ContactCustomerService;